import React, {useState, useEffect} from 'react'
import styles from "./aea-fade-loader.module.scss";
import { FadeLoader } from 'react-spinners';

export interface AEAFadeLoaderProps {
    loading: boolean;
    currentData?: boolean;
    text?: string;
}

const Loader = ({ loading, currentData, text }: AEAFadeLoaderProps) => {
    const [first, setfirst] = useState(false)

    useEffect(() => {
        let isApiSubscribed = true;
        if(!loading) setTimeout(() => { 
            if(isApiSubscribed) setfirst(true)
        }, 1000);
        return () => { isApiSubscribed = false };
    }, [loading])

    useEffect(() => {
        let isApiSubscribed = true;
        if(!currentData && first && isApiSubscribed) setfirst(false)
        return () => { isApiSubscribed = false };
    }, [currentData])
    
    if(loading && !first){
        return (
            <div className={styles.loaderContainer}>
                <div className={styles.loader}>
                    <FadeLoader loading={true} height={20} margin={10} width={5} radius={5} color="#CCC"></FadeLoader>
                    {!!text && <label>{text}</label>}
                </div>
            </div>
        )
    } else {
        return (
            <div className={!first ? styles.loaderAnimation : styles.loaderAnimation2}>
                <div className={styles.loader}>
                    <FadeLoader loading={true} height={20} margin={10} width={5} radius={5} color="#CCC"></FadeLoader>
                    {!!text && <label>{text}</label>}
                </div>
            </div>
        )
    }
}
export default Loader;
